export default __webpack_public_path__ + "static/media/hnbassurance.ff1f2871.png";